import Rete from "rete";
import { cardLogic } from "../../../hoc/ApolloProvider";
import { BodyControl } from "../Controls/BodyControl";
import { StatusControl } from "../Controls/StatusControl";
import { actionSocket } from "../Sockets/Sockets";

export class StartCardNode extends Rete.Component {
    static type = "StartCard";
    public task:any;

    constructor() {
        super(StartCardNode.type);
        this.task = {
            outputs: {}
        };
    }

    builder(node) {
        //console.log("Create Card", "StartCard", node.id, node.data);

        if(node.data.body === undefined && node.name === 'StartCard'){
            node.data = {
                label: "Start Card",
                properties: ["ENTRY_POINT"],
                header: [],
                status: "pending",
                body: ["입력합니다.",{"cat":1,"type": 0, "action":["","","",""],"rules":["plus"]},1,""],
                actions: [
                    {
                        id: "Connect_1",
                        type: "CONNECT_ACTION",
                        text: "다음",
                        img: "",
                        outputs:[],
                    }
                ]
            };
        }

        node.data.body[1].cat = 1;
        if( node.data.body[1].action.length !== 0 )
            cardLogic().outputKeys = node.data.body[1].rules;  
        else      
            node.data.body[1].action = cardLogic().outputKeys;

        const body = new BodyControl(
            this.editor,
            node.data.body,
            node.id + "_BODY",
            StartCardNode.type
        );

        const status = new StatusControl(
            this.editor,
            node.data.status,
            node.id + "_STATUS",
            StartCardNode.type
        );

        node.addControl(status).addControl(body);
        

        if ( node.data.properties && !node.data.properties.includes("ENTRY_POINT")) {
            node.addInput(new Rete.Input("act", "Link", actionSocket, true));
        }

        if (node.data.actions) {
            node.data.actions.forEach(action => {
                node.addOutput( new Rete.Output(action.id, action.text, actionSocket, false));
            });
        }
        
        return node;
    }

    worker(node, inputs, outputs) {
        //console.log("StartCard", "worker", node.id, node.data);
        if (!this.editor)
            return
        const nodeRef = this.editor.nodes.find(it => it.id === node.id)
        if (!nodeRef)
            return
    }
}
